module.exports = __webpack_public_path__ + "img/logo.4ac56d3a.jpg";